/** Which event target a keyboard binding reacts on. */
export enum InputFocus {
    /** Anywhere, including text inputs. */
    Any = 'any',
    /** Anywhere except text inputs. */
    NoTextInput = 'noTextInput',
    /** Only when the 3D scene container has focus. */
    Scene = 'scene'
}
